var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoesWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feature_01",
    transform: "translate(-170 -1239)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8424",
    "data-name": "\\uC0AC\\uAC01\\uD615 8424",
    width: 50,
    height: 50,
    transform: "translate(170 1239)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20495",
    "data-name": "\\uADF8\\uB8F9 20495",
    transform: "translate(-0.317 0.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20414",
    "data-name": "\\uADF8\\uB8F9 20414",
    transform: "translate(147.759 566.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2435",
    "data-name": "\\uD328\\uC2A4 2435",
    d: "M28.229,22.641H8.854A1.717,1.717,0,0,1,7.32,20.787V19.455H29.763v1.332A1.717,1.717,0,0,1,28.229,22.641Z",
    transform: "translate(29.365 678.82)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2436",
    "data-name": "\\uD328\\uC2A4 2436",
    d: "M32.22,27.443H17.728a2.362,2.362,0,0,0-2.2,1.229L12.316,40.516H37.633L34.418,28.672A2.365,2.365,0,0,0,32.22,27.443Z",
    transform: "translate(22.932 676.066)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8393",
    "data-name": "\\uC0AC\\uAC01\\uD615 8393",
    width: 2.528,
    height: 2.047,
    transform: "translate(46.642 701.461)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20415",
    "data-name": "\\uADF8\\uB8F9 20415",
    transform: "translate(-7841.152 728.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20397",
    "data-name": "\\uADF8\\uB8F9 20397",
    transform: "translate(8018.47 515.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2430",
    "data-name": "\\uD328\\uC2A4 2430",
    d: "M14.848,7.127a24.008,24.008,0,0,0,12.813,6.034c7.3.892,9.729,3.616,10.73,6.2a9.965,9.965,0,0,1,.412,4.516,1.677,1.677,0,0,1-1.618,1.463H4.135a1.764,1.764,0,0,1-1.727-1.806C2.352,22.486.955,15.222,3.67,11.091A11.094,11.094,0,0,0,14.848,7.127Z",
    transform: "translate(-1.999 -5.201)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2431",
    "data-name": "\\uD328\\uC2A4 2431",
    d: "M19.109,8.26l-1.39-2.7L21.96,2.643s1.648,1.835,2.124,2.184",
    transform: "translate(-10.966 -2.643)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_2",
    "data-name": "\\uC120 2",
    x2: 36.052,
    transform: "translate(0.535 15.678)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2432",
    "data-name": "\\uD328\\uC2A4 2432",
    d: "M8.593,31.584a5.682,5.682,0,0,0-5.807-5.69",
    transform: "translate(-2.448 -15.906)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2433",
    "data-name": "\\uD328\\uC2A4 2433",
    d: "M65.361,25.611s-.155,2.8-3.611,2.713-4.346.488-4.932,1.266a5.618,5.618,0,0,0-.713,1.833",
    transform: "translate(-32.9 -15.745)",
    fill: "none",
    stroke: "#040405",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_4",
    "data-name": "\\uC120 4",
    x1: 2.196,
    y2: 2.925,
    transform: "translate(14.967 5.617)",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_5",
    "data-name": "\\uC120 5",
    x1: 2.196,
    y2: 2.925,
    transform: "translate(19.617 7.639)",
    fill: "none",
    stroke: "#040405",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20416",
    "data-name": "\\uADF8\\uB8F9 20416",
    transform: "translate(142.165 561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_319",
    "data-name": "\\uD0C0\\uC6D0 319",
    cx: 3.133,
    cy: 3.133,
    r: 3.133,
    transform: "translate(50.367 713.367)",
    fill: "#ef6156"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2437",
    "data-name": "\\uD328\\uC2A4 2437",
    d: "M4440.742-1023.005l.789-3.174.751,3.174Z",
    transform: "translate(-4388 1736.711)",
    fill: "#ef6156"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoesWeight);
export default __webpack_public_path__ + "static/media/shoes_weight.dd3630d42ed67c04d24ef4fe1ccca7f0.svg";
export { ForwardRef as ReactComponent };